export default __webpack_public_path__ + "static/media/ie-office-free-logo.9160330e.svg";